import { Component } from 'react';

import { faExclamationTriangle, faSparkles } from '@awesome.me/kit-24322b77ac/icons/classic/solid';
import type { ErrorInfo, ReactNode } from 'react';

import { Icon } from '../Icon/Icon';

import './ErrorBoundary.less';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  public override state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public override componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error(`Uncaught error: ${error}`, errorInfo);
  }

  public override render(): ReactNode {
    if (this.state.hasError) {
      if (this.state.error?.name === 'ChunkLoadError') {
        return (
          <div className="error-boundary">
            <div>
              <Icon icon={faSparkles} size="lg" />
            </div>
            <div>This game has been updated, please refresh your browser to get the latest update.</div>
          </div>
        );
      }
      return (
        <div className="error-boundary">
          <div>
            <Icon icon={faExclamationTriangle} size="lg" />
          </div>
          <div>An error has occurred, please refresh and try again...</div>
        </div>
      );
    }

    return this.props.children;
  }
}
